<template>
  <div class="main-app-login">
    <div class="container">
      <div class="img-area">
        <img src="../assets/login-3.png" class="img" alt />
      </div>
      <div class="form-area">
        <div class="form">
          <div class="sec-title">
            <span class="h2" v-if="!isFrom"> 欢迎使用 AI分销</span>
            <span class="h2" v-if="isFrom"> 正在登录中......</span>
          </div>
          <div class="input-item">
            <img src="../assets/user.png" class="input-user-icon" />
            <input
              class="form-input input-padd"
              type="text"
              autofocus
              placeholder="请输入您的手机号"
              @keyup.enter="login"
              @input="accountWarn = ''"
              v-model="form.account"
            />
            <div class="input-item-tip" v-if="accountWarn">
              {{ accountWarn }}
            </div>
          </div>
          <div class="input-item">
            <img src="../assets/pass.png" class="input-pass-icon" />
            <input
              class="form-input input-padd"
              type="password"
              autofocus
              @input="passwordWarn = ''"
              @keyup.enter="login"
              placeholder="请输入您的密码"
              v-model="form.password"
            />
            <div class="input-item-tip" v-if="passwordWarn">
              {{ passwordWarn }}
            </div>
          </div>
          <div style="display: flex; margin-bottom: 25px" v-if="!isFrom">
            <div>
              <div class="checkbox" @click="autoLoginChecked">
                <img
                  v-if="checked"
                  style="width: 20px; height: 20px"
                  src="../assets/checkbox.png"
                  alt=""
                />
                <img
                  v-else
                  style="width: 20px; height: 20px"
                  src="../assets/checkbox-def.png"
                  alt=""
                />
                <p style="margin-left: 12px">自动登录</p>
              </div>
            </div>
            <span class="password-forget" @click="toResetPwd">忘记密码</span>
          </div>
          <button
            class="form-btn"
            type="primary"
            @click="login"
            @keyup.enter="login"
          >
            登录
          </button>
          <div class="agreement">登录即表示已同意AI分销服务协议</div>
        </div>
        <div class="register" v-if="!isFrom">
          <button class="button-min" type="primary" @click="register">
            <span style="color: #999999">没有账号？</span>立即注册
          </button>
        </div>
        <div class="copyright">
          copyright© 2018-{{
            new Date().getFullYear()
          }}.布谷云软件技术(南京)有限公司<span style="margin-left: 10px"></span
          >联系电话：400-166-9695
        </div>
      </div>
    </div>
    <dialog-select ref="dialogSelect"></dialog-select>
  </div>
</template>

<script>
import dialogSelect from "../components/select.vue";
export default {
  name: "Login",
  data() {
    return {
      form: {
        account: "",
        password: "",
      },
      checked: false,
      passwordWarn: "",
      autoLogin: true,
      accountWarn: "",
      loading: false,
      wxToken: "",
      tips: "",
      tips2: "",
      loginKey: "",
      isFrom: false,
    };
  },
  created() {
    let loginId = this.getUrlValue("account");
    let password = this.getUrlValue("password");

    if (loginId && password) {
      this.isFrom = true;
      this.form.account = loginId;
      this.form.password = password;
      this.login();
    }
  },
  mounted() {
    if (window.localStorage["AKX_AUTO_LOGIN_CONFIG"] === "1") {
      this.checked = true;
    } else {
      this.checked = false;
    }
  },
  components: {
    dialogSelect,
  },
  methods: {
    autoLoginChecked() {
      this.checked = !this.checked;
    },
    login() {
      if (!this.loading && this.validation()) {
        this.loading = true;
        this.$api.login({
          headers: {
            // token: 'bd368a9ae6ac47849d904258a60797e1'
          },
          params: {
            "USER.LOGIN_ID": this.form.account,
            "USER.LOGIN_PASSWORD": this.form.password,
            APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
            $DEBUG: "11358udbu14623",
          },
          free: true,
          success: (res) => {
            console.log(res);
            let result = res.extraData;
            if (result["USER_LIST"] && result["USER_LIST"].length > 1) {
              result["USER_LIST"].map((ele) => {
                ele.name = ele["USER.NAME"];
              });
              console.log("执行到这里了~~~", result["USER_LIST"]);
              this.$refs.dialogSelect.show({
                list: result["USER_LIST"],
                title: "选择登录角色",
                select: (res) => {
                  console.log(res);
                  this.$api.selectService({
                    headers: {
                      // token: 'bd368a9ae6ac47849d904258a60797e1'
                      // token: '72d849798ae24998b7f3e34611a0f840'
                    },
                    params: {
                      // TOKEN: result.token,
                      "USER.LOGIN_ID": res["USER.LOGIN_ID"],
                      SERVICE_ID: res["SERVICE_ID"],
                      // TYPE_NAME: res["USER.TYPE_NAME"],
                      SECRET_KEY: res["SECRET_KEY"],
                      APP_TOKEN: "9C4F2C2F67E34BB29BF296DBDBF26922",
                      // _KEY: this.loginKey
                    },
                    success: (res) => {
                      // if (res.extraData.openIdStatus === "fail") {
                      //   alert(
                      //     "该账号已经绑定其他微信，本次绑定失败，可以去修改密码清空绑定"
                      //   );
                      // }
                      // console.log(res)
                      // console.log(result)
                      // result.bubuId = res.extraData.bubuId;
                      result.token = res.extraData.token;
                      this.loginSuccess(result);
                    },
                  });
                },
              });
            } else {
              console.log("1");
              setTimeout(() => {
                this.loginSuccess(result);
              }, 1000);
            }
          },
          fail: (res) => {
            if (res && res.msg) {
              if (this.isFrom) {
                alert(`${res.msg}`);
              }
              if (res.msg.indexOf("密码") !== -1) {
                this.passwordWarn = res.msg;
              } else {
                this.accountWarn = res.msg;
              }
            }
          },
          complete: () => {
            this.loading = false;
          },
        });
      }
    },
    getUrlValue(key) {
      const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
      const arr = window.location.search.substring(1).match(reg);

      return (arr && arr[2]) || "";
    },
    loginSuccess(result) {
      console.log("11");
      let bubuId = result.token;
      if (this.checked) {
        window.localStorage.setItem("AKX_AUTO_LOGIN_CONFIG", "1");
      } else {
        window.localStorage.setItem("AKX_AUTO_LOGIN_CONFIG", "-1");
        window.sessionStorage.setItem("LOGIN_FLAG", 1);
      }
      window.localStorage.setItem(
        "USER_TOKEN",
        bubuId.substr(bubuId.length - 32, 32)
      );
      let pathname;
      if (location.pathname.indexOf("login.html") !== -1) {
        pathname = location.pathname.replace("login.html", "index.html");
      } else {
        pathname = "/";
      }
      let url = location.origin + pathname;
      location.replace(url);
    },
    validation() {
      this.accountWarn = "";
      this.passwordWarn = "";
      if (!this.form.account) {
        this.accountWarn = "账号不能为空";
        return false;
      }
      if (!this.form.password) {
        this.passwordWarn = "密码不能为空";
        return false;
      }
      return true;
    },
    register() {
      this.$router.push({
        path: "/register",
      });
    },
    toResetPwd() {
      this.$router.push({
        path: "/pass",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.input-user-icon {
  width: 20px;
  height: 21px;
  position: absolute;
  top: 14px;
  left: 13px;
}

.input-pass-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 14px;
  left: 10px;
}

.error {
  margin-top: 3px;
  width: 13px;
  height: 13px;
}
.main-app-login {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  .container {
    max-width: 1014px;
    min-width: 828px;
    width: 80%;
    height: 610px;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    .img-area {
      width: 428px;
      height: 610px;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      .text {
        position: absolute;
        top: 18%;
        left: -10%;
      }
      .img {
        width: 602px;
        height: 546px;
        display: block;
        transform: translate(-50%, -50%);
        position: absolute;
        top: 56%;
        left: 45%;
      }
    }
  }
  .input-item {
    padding-bottom: 30px;
    position: relative;
  }
  .input-padd {
    padding-left: 46px;
  }
  .input-item-tip {
    position: absolute;
    left: 0;
    bottom: 4px;
    font-size: 14px;
    color: #f46c50;
    line-height: 21px;
  }
  .input-item-tip:before {
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-position: center;
    background-size: contain;
    vertical-align: middle;
    margin-right: 5px;
    background-image: url(../assets/cut.png);
  }
  .form-area {
    position: absolute;
    min-width: 480px;
    height: 557px;
    background-color: #ffffff;
    right: 0;
    left: 568px;
    // top: 10%;
    bottom: 5%;
    box-shadow: 0px 8px 24px 0px rgba(240, 232, 232, 0.79);
    .form {
      width: 361px;
      max-width: 100%;
      padding-left: 5px;
      padding-right: 5px;
      transform: translate(-50%, -50%);
      position: absolute;
      top: 45%;
      left: 49.5%;
    }
    .register {
      width: 100%;
      position: absolute;
      top: 88%;
      left: 0%;
      box-shadow: 0px 8px 24px 0px rgba(240, 232, 232, 0.79);
      height: 66px;
      background-color: #f8f8f8;
    }
    .password-forget {
      color: #f46c50;
      font-size: 16px;
      margin-left: auto;
    }
    .password-forget:hover {
      cursor: pointer;
    }
    .agreement {
      margin-top: 10px;
      margin-left: 2px;
      font-size: 12px;
      color: #999999;
    }
    .title {
      font-size: 30px;
      color: #fff;
      margin-bottom: 20px;
    }
    .sec-title {
      margin-bottom: 30px;
    }
    .h2 {
      position: absolute;
      top: -9%;
      left: 1%;
      font-size: 24px;
      font-weight: bold;
      color: #333333;
      margin-right: 5px;
    }
    .copyright {
      position: absolute;
      bottom: -25px;
      left: 0;
      right: 0;
      text-align: center;
      color: #999999;
      font-size: 12px;
    }
    .h3 {
      font-size: 20px;
      color: #fff;
    }
  }
  .button-min {
    color: #ff5c50;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0);
    outline: none;
    border: none;
    margin: 0 auto;
    display: block;
    padding: 0 5px;
    margin-top: 19px;
  }
  .button-min:hover {
    cursor: pointer;
    color: #f97e3c;
  }
  .checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
